import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export function WineClubBenefitsPage() {
  return <div className="min-h-screen bg-white" data-id="element-1779">
      {/* Header */}
      <Header variant="solid" data-id="element-1780" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-1781">
        <div className="max-w-4xl mx-auto" data-id="element-1782">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-1783">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-1784">
              News & Events
            </a>
            <span className="mx-2" data-id="element-1785">/</span>
            <span className="text-neutral-900" data-id="element-1786">
              Woo-Hoo we love our Peterson House Wine Club!
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-1787">
            Woo-Hoo we love our Peterson House Wine Club!
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-1788">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/landscape-cd-entry-with-wine-wall.jpg" alt="Wine Club Benefits" className="w-full h-full object-cover" data-id="element-1789" />
          </div>

          {/* Content */}
          <article className="max-w-none" data-id="element-1790">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1791">
              Thinking of joining the best sparkling Wine Club in the Hunter
              Valley? Let's talk about why you should.
            </p>

            {/* Team Introduction */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-1792">
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1793">
                Our members are in the best hands here at Peterson House, the
                team has years of experience and a healthy love for all things
                sparkling wine under their belts.
              </p>
            </div>

            {/* Exclusive Events */}
            <div className="mb-8" data-id="element-1794">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1795">
                Exclusive Events Across the East Coast
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1796">
                When you become a member of our Peterson House Wine Club you
                become a bubbly part of our incredible community, experiencing
                exclusive events all over the East Coast! We offer Wine Club
                dinners, lunches, markets, the occasional cooking class, and
                festivals from Brisbane to Canberra.
              </p>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1797">
                Don't forget our annual Sydney Harbor Wine Club Cruise, three
                hours on a Saturday afternoon sailing with endless bubbles! This
                themed event is an absolute knockout every single year.
              </p>
            </div>

            {/* Hunter Valley Experiences */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-1798">
              <h3 className="font-heading text-2xl text-neutral-900 mb-6" data-id="element-1799">
                Hunter Valley Experiences
              </h3>

              <div className="space-y-6" data-id="element-1800">
                <div data-id="element-1801">
                  <h4 className="font-medium text-neutral-900 mb-2 text-lg" data-id="element-1802">
                    Bubbleologist Experience
                  </h4>
                  <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1803">
                    Happens three times a year, where our Wine Club members and
                    friends become a wine maker for the day. Explore the
                    winemaking process in our production facility, where you
                    create your own personal blend of sparkling wine to take
                    home! Followed by a four-course wine paired lunch in
                    Restaurant Cuvée.
                  </p>
                </div>

                <div data-id="element-1804">
                  <h4 className="font-medium text-neutral-900 mb-2 text-lg" data-id="element-1805">
                    Harvest Experience
                  </h4>
                  <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1806">
                    Our club members harvest the vines on our property here at
                    Peterson House. After battling the vines (and a few spiders)
                    you can relax and enjoy a two-course breakfast in Restaurant
                    Cuvée, finishing with a fascinating talk from our expert
                    bubbleologist Geoff on the sparkling journey from grape to
                    glass.
                  </p>
                </div>

                <div data-id="element-1807">
                  <h4 className="font-medium text-neutral-900 mb-2 text-lg" data-id="element-1808">
                    Winter Feast
                  </h4>
                  <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1809">
                    Our annual sparkling soirée (formerly Christmas in July).
                    This beautiful winters evening is full of incredible food,
                    flowing bubbles and the very best company!
                  </p>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="mb-8" data-id="element-1810">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1811">
                Member Benefits
              </h3>
              <ul className="space-y-3" data-id="element-1812">
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-1813">
                  <span className="text-brand-pink mt-1" data-id="element-1814">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1815">
                    No sign-up fee, just commit to 12 months' worth of
                    deliveries
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-1816">
                  <span className="text-brand-pink mt-1" data-id="element-1817">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1818">
                    Complimentary tastings for up to six guests
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-1819">
                  <span className="text-brand-pink mt-1" data-id="element-1820">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1821">
                    15% off wines all year round
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-1822">
                  <span className="text-brand-pink mt-1" data-id="element-1823">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1824">
                    15% off souvenirs and meals in Restaurant Cuvée
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-1825">
                  <span className="text-brand-pink mt-1" data-id="element-1826">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1827">
                    Extra love if you visit any of our sister companies
                  </span>
                </li>
              </ul>
            </div>

            {/* Wine Club Options */}
            <div className="my-12" data-id="element-1828">
              <h3 className="font-heading text-3xl text-neutral-900 mb-8 text-center" data-id="element-1829">
                Our Wine Club Options
              </h3>

              <div className="grid md:grid-cols-2 gap-8" data-id="element-1830">
                {/* Pink Club */}
                <div className="border border-neutral-200 p-8 bg-white" data-id="element-1831">
                  <h4 className="font-heading text-2xl text-brand-pink mb-4" data-id="element-1832">
                    Pink Club
                  </h4>
                  <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1833">
                    Suited to the sweeter bubble lover! Enjoy Pink Blush Rosé,
                    or Dolce Per Tutti Moscato, plus other delicious options.
                  </p>
                  <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1834">
                    Six bottles delivered every April, August, and November.
                    Choose a selection created for you or choose your own!
                  </p>
                  <div className="bg-brand-pink/10 p-4 mt-6" data-id="element-1835">
                    <p className="text-neutral-700 text-sm leading-relaxed italic" data-id="element-1836">
                      <strong data-id="element-1837">Fun Fact:</strong> The Pink Club was created due
                      to everyone's love for our Pink Blush Rosé!
                    </p>
                  </div>
                </div>

                {/* Premium Club */}
                <div className="border border-neutral-200 p-8 bg-white" data-id="element-1838">
                  <h4 className="font-heading text-2xl text-brand-grey mb-4" data-id="element-1839">
                    Premium Club
                  </h4>
                  <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1840">
                    Tailored to those who enjoy a more traditional methode
                    sparkling wine like our flagship Pinot Noir Chardonnay
                    Meunier, our popular Blanc De Blanc and our range of
                    sparkling Shiraz reserve wines.
                  </p>
                  <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1841">
                    Three deliveries of four bottles every March, June, and
                    October.
                  </p>
                  <div className="bg-neutral-100 p-4 mt-6" data-id="element-1842">
                    <p className="text-neutral-700 text-sm leading-relaxed" data-id="element-1843">
                      <strong data-id="element-1844">VIP Access:</strong> Premium members get exclusive
                      first access to our latest bubbles!
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Closing */}
            <div className="mb-8" data-id="element-1845">
              <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1846">
                Are we making you want to join yet? Pop online or into our
                cellar door, have a taste and sign up today! Your benefits are
                instant and your love for sparkling wines will only grow.
              </p>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1847">
                We love getting to know our members personally so that each
                experience is tailored to you. So, let's have a chat to make
                your Hunter Valley experience the best one yet!
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-brand-pink/5 p-8 my-12 text-center" data-id="element-1848">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1849">
                Ready to Join?
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-6" data-id="element-1850">
                Become part of the Peterson House Wine Club family and enjoy
                exclusive events, premium wines, and unforgettable experiences.
              </p>
              <a href="/wine-club" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1851">
                Join Wine Club
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1852" />
              </a>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-1853">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1854">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1855" />
    </div>;
}